import React from 'react';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import Loadable from '@loadable/component';

import './delivery-proposal.styles.scss';

const Pulse = Loadable(() => import('react-reveal/Pulse'));

const DeliveryProposal = () => {
  return (
    <Pulse>
      <div className="delivery-proposal ptb-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="delivery-proposal-image">
                <img
                  src={require('../../../assets/photos/product-statement/delivery-plan.png')}
                  alt="banner"
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="delivery-proposal-content">
                <h2>Delivery Solution</h2>
                <p>
                  Hop In is providing a delivery service to bring an affordable
                  option to small businesses.
                </p>
                <AniLink
                  paintDrip
                  hex="#ff5d22"
                  to="/delivery"
                  className="default-btn"
                >
                  <i className="flaticon-right"></i> Delivery Logistics{' '}
                  <span></span>
                </AniLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Pulse>
  );
};

export default DeliveryProposal;
